'use strict';

import Popup from './popup/popup.directive';
import Checkbox from './checkbox/checkbox.directive';
import Dropdown from './dropdown/dropdown.directive';
import Navbar from './navbar/navbar.directive';
import Toasts from './toasts/toasts.directive';
import Slider from './slider/slider.component';

export default angular
  .module('maestro.directives.semantic', [
    Popup,
    Checkbox,
    Dropdown,
    Navbar,
    Toasts,
    Slider
  ])

  .name;
